import { DEFAULT_LOCALE, COOKIE_KEY_LOCALE, locales } from '@flex-packages/i18n-base';
import Cookies from 'universal-cookie';

function isServerSidePropsContext(context) {
  return "req" in context;
}
function decideLocale(context, cookies) {
  if (!isServerSidePropsContext(context)) {
    return DEFAULT_LOCALE;
  }
  const cookie = cookies || new Cookies(context.req.cookies);
  const previousLocale = cookie.get(COOKIE_KEY_LOCALE);
  if (previousLocale != null) {
    for (const locale of locales) {
      if (previousLocale === locale) {
        return locale;
      }
    }
  }
  return DEFAULT_LOCALE;
}

export { decideLocale };
//# sourceMappingURL=decideLocale.mjs.map
